import Cookies from 'js-cookie'

const TokenKey = 'ffToken'

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setTokenByKey(key,token){
  return Cookies.set(key,token);
}

export function getTokenByKey(key){
  return Cookies.get(key);
}

export function removeTokenByKey(key){
  return Cookies.remove(key);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js